import PropTypes from "prop-types";
// @mui
import { TableRow, TableCell } from "@mui/material";
import Label from "../../../../components/label";

// components

import { fNumber } from "src/utils/formatNumber";

// ----------------------------------------------------------------------

CustomerReservationTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
  onEditRow: PropTypes.func,
  onDeleteRow: PropTypes.func,
  onSelectRow: PropTypes.func,
  handleOpenUserReservationDetailModal: PropTypes.func,
};

export default function CustomerReservationTableRow({
  row,
  handleOpenUserReservationDetailModal,
  getSingleData,
}) {
  const {
    reservationNo,
    createdAt,
    paymentType,
    reservationType,
    partySize,
    origin,
    advancePayment,
    status,
    venue
  } = row;

  const formatTime = (time) => {
    const options = { hour: "2-digit", minute: "2-digit", hour12: true };
    return new Intl.DateTimeFormat("en-US", options).format(time);
  };

  const formatDate = (time) => {
    const options = { day: "numeric", month: "short", year: "numeric" };
    return new Intl.DateTimeFormat("en-US", options).format(time);
  };

  const newCreatedAtDate = new Date(createdAt);
  var options = {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  var formattedTime = newCreatedAtDate.toLocaleString("en-US", options);

  const getDisplayOrderType = (origin) => {
    switch (origin) {
      case "web":
        return "Web";
      case "venue":
        return "venue";
      case "widget":
        return "Widget";
      case "web":
        return "Web";
      case "app":
        return "App";
      case "store":
        return "Store";
      default:
        return "-";
    }
  };

  const openModal = () => {
    handleOpenUserReservationDetailModal();
    getSingleData(row);
  };

  return (
    <>
      <TableRow hover onClick={openModal} sx={{ cursor: "pointer" }}>
        <TableCell align="left">
          {reservationNo == 0 ? "-" : reservationNo}
        </TableCell>
        <TableCell align="left">{formatDate(new Date(createdAt))}</TableCell>
        <TableCell align="left">{formatTime(new Date(createdAt))}</TableCell>
        <TableCell align="left">{reservationType}</TableCell>
        <TableCell align="left">{partySize}</TableCell>
        <TableCell align="left">
          <Label
            variant="soft"
            color={
              origin === "web"
                ? "success"
                : origin === "venue"
                ? "secondary"
                : origin === "app"
                ? "error"
                : origin === "widget"
                ? "warning"
                : "info"
            }
            sx={{ textTransform: "capitalize" }}
          >
            {getDisplayOrderType(origin)}
          </Label>
        </TableCell>

        <TableCell align="left">
          Rs. {fNumber(advancePayment?.amount.toFixed(venue.decimalPoints))}
        </TableCell>

        <TableCell align="left">
          <Label
            variant="soft"
            color={
              (row?.advancePayment?.status === "pending" && "error") ||
              (row?.advancePayment?.status === "received" && "success") ||
              "secondary"
            }
            sx={{ textTransform: "capitalize" }}
          >
            {row?.advancePayment?.status || "Not Required"}
          </Label>
        </TableCell>

        <TableCell align="left">
          <Label
            variant="soft"
            color={
              ((status === "checkin" || status === "pending") && "info") ||
              (status === "noShow" && "secondary") ||
              ((status === "refunded" || status === "cancelled") && "error") ||
              (status === "finished" && "warning") ||
              "success"
            }
            sx={{ textTransform: "capitalize" }}
          >
            {status}
          </Label>
        </TableCell>
      </TableRow>
    </>
  );
}
